import { lazy } from "react";

export { DYNAMIC_ENUM_EDITOR } from "./enum-editor-path";
export const DynamicEnumEditorPage = lazy(() => import("./enum-editor"));
